var prodcat = prodcat || {};

(function($) {
  // @todo make these more dynamic, maybe come in from drupal settings.
  var gridWrapperClass = '.js-mpp-grid';
  var gridItemClass = '.js-mpp-grid-item';
  var gridBypassReorderClass = 'js-mpp-grid--bypass-reorder';

  // @todo this could be customizeable per brand as well.
  // Statuses that trigger reorder.
  var reorderStatuses = [
    // 2, // Temporarily Sold Out
    // 3, // Coming Soon
    7 // Sold Out
  ];

  $(document).on('inv_status_data:updated', '.js-product', function() {
    var $updatedProduct = $(this);
    var $gridWrapper = $updatedProduct.closest(gridWrapperClass);
    var skuBaseId = $updatedProduct.data('sku-base-id');

    //not every element in grid has a Sku ID
    if (!skuBaseId) {
      return;
    };

    var skuDataL2 = prodcat.data.getSku(skuBaseId);

    // Validate grid wrapper.
    if (!$gridWrapper.length || $gridWrapper.hasClass(gridBypassReorderClass)) {
      return;
    }

    // Returns boolean of whether we should shuffle element.
    var shouldReorder = function(l2Cache) {
      // return l2Cache.SKU_BASE_ID === 62985;
      return _.contains(reorderStatuses, parseInt(l2Cache.INVENTORY_STATUS));
    };

    // Takes current element and moves it to the end of the grid.
    var reorderGridItem = function($el) {
      var $gridItem = $el.closest(gridItemClass);
      var $carousel = $el.closest('.slick-slider');
      var $mixitup = $el.closest('.mixitup-initialized');

      if (!$gridItem.length) {
        return;
      }

      // If slick carousel, use their API, else do it the old fashioned way.
      if ($mixitup.length) {
        // @todo determine if mixitup sorting should be handled here
        // for now i'm doing the resorting without sort js
      } else if ($carousel.length) {
        $carousel.slickRemove($gridItem.index()).slickAdd($gridItem);
      } else {
        $gridItem.appendTo($gridItem.parent());
      }
    };

    // Reordering sold out products (inv. status 7), to be last in display order on MPPs/anywhere they appear in a grid
    if (shouldReorder(skuDataL2)) {
      reorderGridItem($updatedProduct);
    }
  });
})(jQuery);
